﻿document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener("click", function (event) {
    const target = event.target.closest(".js-toggle-text");

    if (target) {
      const originalText = target.textContent;
      const openText = target.dataset.opentext;
      const closeText = target.dataset.closetext;
      const newText = originalText === openText ? closeText : openText;
      target.textContent = newText;
    }
  });
});
